// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */
import * as React from 'react';
import { localize } from '@ta/common.i18n';
import { Link } from '@ta/common.routing';
import { Toaster, type ToastType } from '@ta/overlays.toast';
import type { RepostStatus } from '@ta/social.types';

type Props = {|
  /** Children, responsible for triggering the toast */
  children: (
    (repostContentType: string, repostStatus: RepostStatus, username?: string) => void,
  ) => React.Node,
|};

/**
 * A toast displayed on upon a repost
 * Contains link to the profile activity tab
 */
class RepostToast extends React.Component<Props> {
  createToast(repostObjectType: string, repostStatus: RepostStatus, username?: string): ToastType {
    switch (repostStatus) {
      case 'success':
        return {
          node: this.successToastMessage[repostObjectType],
          /* View post */
          cta: (
            <Link
              href={username ? `/Profile/${username}` : '/Profile'}
              to={{ page: 'Profile', username }}
            >
              {localize('view_repost')}
            </Link>
          ),
        };
      case 'error':
        return {
          node: localize(
            'repost_failure_message',
          ) /* Your repost failed to upload. Please try again. */,
        };
      case 'rate_limited':
        return {
          node: localize(
            'repost_rate_limited_v2',
          ) /* Your repost failed to upload. You have exceeded the limit of allowed reposts. */,
        };
      case 'no_permission':
        return {
          /** You don't have permission to take this action.  */
          node: localize('social_no_permission'),
        };
      default:
        return { node: '' };
    }
  }

  successToastMessage = {
    Review: localize('success_repost_review') /* Your review was posted! */,
    Photo: localize('success_repost_photo') /* Your photo was posted! */,
    Video: localize('success_repost_video') /* Your video was posted! */,
    ForumPost: localize('success_repost_forum') /* Your forum was posted! */,
    LinkPost: localize('success_repost_link') /* Your link was posted! */,
    Trip: localize('success_repost_trip') /* Your trip was posted! */,
    MediaBatch: localize('success_repost_photos') /* Your photos were posted */,
  };

  render() {
    return (
      <Toaster>
        {launchToast =>
          this.props.children(
            (repostContentType: string, repostStatus: RepostStatus, username?: string) => {
              launchToast(this.createToast(repostContentType, repostStatus, username));
            },
          )
        }
      </Toaster>
    );
  }
}

export default RepostToast;
